import React, { Component } from "react";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import UserDefault from "Assets/img/default-user.png";
import moment from "moment";
import MessageFileIcon from "Assets/img/messageFileIcon.png";
import ModalImage from "react-modal-image";
import ReactPlayer from 'react-player'
import StoredData from "Constants/StoredData";

class MessageBlock extends Component {

    
     // Check file over 2 week 
     checkTimeAttachment(timeSendFile) {
        const datePast = timeSendFile;
        const diffDate = moment().diff(moment(datePast), 'weeks');
        return diffDate
    }

    showFile(messageObject) {
        switch (Number(messageObject.type_message)) {
            case 1 :
                const fileName = messageObject.name_file.length > 15 ? `${messageObject.name_file.slice(0,14)}...` : messageObject.name_file 
                const checkWeeds = this.checkTimeAttachment(messageObject.created_at)
                return <a href={checkWeeds < 2 ? messageObject.file : ''} title={checkWeeds < 2 ? messageObject.name_file ||  '' : ''} className="mt-2">
                        {checkWeeds < 2 ? 
                            (<img 
                                className="img-fluid" 
                                style={{maxHeight: 40, maxWidth: 40}} 
                                src={MessageFileIcon} 
                            />) : <p className="chat-note-attachment">{'File is two weeks out of date'}</p>
                        }
                        <p className="m-0 text-secondary h5">{checkWeeds > 2 ? fileName || '' : ''}</p>
                    </a>
            case 2:
                return  <div>
                           { this.checkTimeAttachment(messageObject.created_at) < 2 ?
                                <ModalImage
                                    small={messageObject.file}
                                    large={messageObject.file}
                                    alt="Gig Image"
                                /> : <p className="chat-note-attachment">{'Image is two weeks out of date'}</p>
                            }
                        </div>
            case 3:
                return <div>
                            { this.checkTimeAttachment(messageObject.created_at) < 2 ?
                                <ReactPlayer
                                    url={messageObject.file}
                                    width='100%'
                                    height='100%'
                                    controls={true}
                                /> : <p className="chat-note-attachment">{'Video is two weeks out of date'}</p>
                            }
                    </div>
                break;    
            default:
                null;
        }
    }
    
    render() {
        const { isEmployer, messageObject } = this.props;
        const providerLogo = StoredData.get(StoredData.KEYS.EMPLOYER_LOGO)
        if (!isEmployer) {
            return (
                <div className="d-flex flex-nowrap pb-0">
                    {messageObject.profile_thumbnail && (
                        <Tooltip
                            title={messageObject.preferred_name}
                            placement="bottom"
                        >
                            <Avatar
                                alt="user profile"
                                src={messageObject.profile_thumbnail}
                                className="img-fluid rounded-circle mr-15 align-self-center"
                            />
                        </Tooltip>
                    )}

                    {messageObject.profile_thumbnail === null && (
                        <Tooltip
                            title={messageObject.preferred_name}
                            placement="bottom"
                        >
                            <Avatar
                                alt="user profile"
                                src={UserDefault}
                                className="img-fluid rounded-circle mr-15 align-self-center"
                            />
                        </Tooltip>
                    )}

                    <div className="chat-bubble odd">
                        <div className="chat-bubble__left">
                            <span className="text-right">
                                {moment(`${messageObject.created_at}`).format("HH:mm DD MMM")}
                            </span>
                            {
                                messageObject.note_text.length ? <p style={{ overflowWrap: 'break-word' }} className="mb-0">{messageObject.note_text}</p> : null
                            }
                            {this.showFile(messageObject)}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="d-flex flex-nowrap flex-row-reverse">
                <Avatar
                    alt="user profile"
                    src={providerLogo}
                    className="img-fluid rounded-circle ml-15 align-self-center"
                />
                 <div className="col-auto p-3 chat-bubble even " style={{maxWidth: 'calc(100% - 60px)'}}>
                    <div className="flex-column">
                        <span className="text-right">
                            {moment(`${messageObject.created_at}`).format("HH:mm DD MMM")}
                        </span>
                        {
                            messageObject.note_text.length ? <p style={{ overflowWrap: 'anywhere' }} className="mb-0">{messageObject.note_text}</p> : null
                        }
                        {this.showFile(messageObject)}
                    </div>
                </div>
            </div>
        );
    }
}

export default MessageBlock;
